

















































































import CommonBase from "../CommonBase";
import {Component} from "vue-property-decorator";
import rd from "../../modules/vRoutedefs";

@Component
export default class RoleInfo extends CommonBase {

    regreminderTo() {
        return {name: rd.start.me.regreminder.name};
    }
}
